import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BadgeCheck, Download, Loader2 } from "lucide-react";
import { API, rupiah, errMsg } from "@/lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("id-ID", { dateStyle: "long", timeStyle: "short" }) : "-");

export default function ReceiptPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    axios.get(`${API}/receipts/${token}`).then((r) => setData(r.data)).catch((e) => setError(errMsg(e, "Kuitansi tidak ditemukan")));
  }, [token]);

  if (error) return <p data-testid="receipt-error" className="max-w-xl mx-auto px-4 py-20 text-center text-red-400">{error}</p>;
  if (!data) return <div className="p-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-[#FF5A00]" /></div>;
  const { order: o, settings: s } = data;
  const rows = [["Kode Pesanan", o.order_code], ["Diterima dari", o.parent_name], ["WhatsApp", o.whatsapp], ["Nama Atlet", o.athlete_name], ["No. BIB", o.bib_number || "-"], ["Klub", o.club], ["Kategori", o.category]];

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-12" data-testid="receipt-page">
      <div className="bg-white text-neutral-900 shadow-[0_0_40px_rgba(255,90,0,0.25)]">
        <div className="h-2 bg-[#FF5A00]" />
        <div className="p-6 sm:p-10">
          <div className="flex items-start justify-between gap-4">
            <img src="/assets/logo.png" alt="Lensa Juara" className="h-20 sm:h-24 w-auto" />
            <div className="text-right">
              <p className="font-display font-black text-3xl sm:text-4xl tracking-tight">KUITANSI</p>
              <p className="text-xs text-neutral-500">No. KW-{o.order_code.slice(3)}</p>
              <p className="text-xs text-neutral-500">{fmt(o.verified_at || o.updated_at)}</p>
            </div>
          </div>
          <p className="mt-6 font-semibold">{s.event_name}</p>
          <p className="text-sm text-neutral-500">{s.event_venue} · {s.event_date}</p>
          <div className="mt-6 grid gap-1.5 text-sm">
            {rows.map(([k, v]) => <div key={k} className="grid grid-cols-[120px_1fr]"><span className="text-neutral-500">{k}</span><span className="font-medium">{v}</span></div>)}
          </div>
          <div className="mt-6 border border-neutral-200">
            <div className="bg-neutral-900 text-white text-xs font-semibold uppercase px-4 py-2 flex justify-between"><span>Mata Lomba</span><span>Galeri</span></div>
            {o.events.map((e, i) => <div key={i} className="px-4 py-2 text-sm flex justify-between border-t border-neutral-200"><span>{i + 1}. {e.name}</span><span className="text-neutral-500">{e.day}</span></div>)}
          </div>
          <div className="mt-6 pt-4 border-t-2 border-[#FF5A00] flex items-end justify-between">
            <span className="font-semibold">TOTAL ({o.event_count} mata lomba)</span>
            <span data-testid="receipt-total" className="font-display font-black text-4xl text-[#FF5A00]">{rupiah(o.total)}</span>
          </div>
          <div className="mt-6 flex items-center gap-3">
            <span data-testid="receipt-paid-badge" className="bg-emerald-600 text-white font-bold px-4 py-1.5 flex items-center gap-1"><BadgeCheck className="w-4 h-4" /> LUNAS</span>
            <p className="text-xs text-neutral-500">Pembayaran telah diverifikasi oleh LENSA JUARA. Kontak WA {s.whatsapp_number}</p>
          </div>
        </div>
        <div className="bg-[#FF5A00] text-white text-center text-xs italic py-2">LENSA JUARA · Setiap Perjuangan Layak Diabadikan.</div>
      </div>
      <a href={`${API}/receipts/${token}/pdf`} data-testid="receipt-download-btn"
        className="mt-6 w-full bg-[#FF5A00] hover:bg-[#E04F00] active:scale-[0.98] transition-[background-color,transform] duration-150 py-4 font-display font-black uppercase text-xl flex items-center justify-center gap-2">
        <Download className="w-5 h-5" /> Unduh Kuitansi PDF
      </a>
    </div>
  );
}
